import jApi from './jApi';

export default {
  getListPrivilegeApp(params) {
    const api = jApi.generateApi();
    return api.get('/application-pages/studio/privilege-application-by-organigram', { params })
      .then(res => res);
  },
  getPrivilegeApp(params) {
    const api = jApi.generateApi();
    return api.get('/dynamic-apps/privelege-application-by-organigram', params)
      .then(res => res.data);
  },
  createPrivilegeApp(params) {
    const api = jApi.generateApi();
    return api.post('/dynamic-apps/studio/privilege-application-by-organigram', params)
      .then(res => res.data);
  },
  deletePrivilegeApp(params) {
    const api = jApi.generateApi();
    return api.delete(`/dynamic-apps/studio/privilege-application-by-organigram/${params}`)
      .then(res => res.data);
  },
  createPrivilegePage(params) {
    const api = jApi.generateApi();
    return api.post('/dynamic-apps/studio/privilege-pages-by-organigram', params)
      .then(res => res.data);
  },

  detailOrganigram(req) {
    const apis = jApi.generateApi();
    return apis.post('jojoflow/organigram/detail-by-user-company', req)
      .then(res => res.data);
  },
};



// WEBPACK FOOTER //
// ./src/services/jApiPrivilege.js